import {PropsWithChildren, useState} from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerOverlay,
  GridItem,
  GridItemProps,
  DrawerCloseButton,
  useBreakpointValue,
  DrawerHeader,
} from '@chakra-ui/react';

import {Filters} from './Filters';
import {PlayersList} from './PlayersList';
import {FiltersT} from '../../types';
import {useTeamsQuery} from '../useTeamsQuery';
import {useLineupStore} from '../useLineupStore';
import {useTranslate} from '@eksab/i18n';
import {useIntl} from 'react-intl';

type FilteredPlayerListProps = {
  competitionId: string;
};

export function FilteredPlayerList({competitionId}: FilteredPlayerListProps) {
  const teamsQuery = useTeamsQuery(competitionId);
  const [filters, setFilters] = useState<FiltersT>({
    price_from: 0,
    price_to: 15,
    team: teamsQuery.data ? `${teamsQuery.data[0].id}` : '',
    q: '',
  });

  return (
    <FiltersContainer>
      <Filters filters={filters} setFilters={setFilters} competitionId={competitionId} />
      <PlayersList filters={filters} competitionId={competitionId} />
    </FiltersContainer>
  );
}

const FiltersContainer = ({children}: PropsWithChildren<{}>) => {
  const shouldRenderDrawer = useBreakpointValue([true, null, false], 'md');

  return shouldRenderDrawer ? (
    <FiltersModal>{children}</FiltersModal>
  ) : (
    <FiltersGridItem bg="white">{children}</FiltersGridItem>
  );
};
const FiltersModal = ({children}: PropsWithChildren<{}>) => {
  const t = useTranslate();
  const isDrawerOpen = useLineupStore((state) => state.isDrawerOpen);
  const closeDrawer = useLineupStore((state) => state.closeDrawer);
  const indicatorPosition = useLineupStore((state) => state.indicatorPosition);
  const formatNumber = useIntl().formatNumber;
  return (
    <Drawer isOpen={isDrawerOpen} onClose={closeDrawer} placement="bottom">
      <DrawerOverlay />
      <DrawerContent marginTop="auto" w="100vw" pt="0" roundedTop="md" height="90%">
        <DrawerHeader>
          {indicatorPosition.substitute
            ? `${t('fantasy.lineup.pick')} ${t('fantasy.lineup.pick_substitute', {
                position: t(`fantasy.lineup.${indicatorPosition.position}`),
              })}
              `
            : `
${t('fantasy.lineup.pick')} ${t(`fantasy.lineup.${indicatorPosition.position}`)} 
${indicatorPosition.position === 'Goalkeeper' ? '' : formatNumber(indicatorPosition.index + 1)}
`}
        </DrawerHeader>
        <DrawerBody pt="0" mt="3">
          {children}
        </DrawerBody>

        <DrawerCloseButton top="4" size="lg" zIndex={200} />
      </DrawerContent>
    </Drawer>
  );
};

const FiltersGridItem = ({children, ...props}: PropsWithChildren<GridItemProps>) => (
  <GridItem rowSpan={4} {...props}>
    {children}
  </GridItem>
);
